<template>
  <div id="scroll">
    <AccountNavbar />
    <div class="content">
      <div class="content-header">
        <h1>Account Settings</h1>
      </div>

      <h2 class="section-header">Notifications</h2>

      <div class="setting-row">
        <label>New Submission Email</label>
        <label class="switch">
          <input type="checkbox" v-model="this.newSubmissionEmailNotify" @change="saveSettings()" />
          <span class="slider round"></span>
        </label>
      </div>

      <div class="setting-row">
        <label>Submission Deleted Email</label>
        <label class="switch">
          <input type="checkbox" v-model="this.deleteSubmissionEmailNotify" @change="saveSettings()" />
          <span class="slider round"></span>
        </label>
      </div>

      <h2 class="section-header">Import Settings</h2>

      <div class="setting-row">
        <label>Open chart after import</label>
        <label class="switch">
          <input type="checkbox" v-model="this.openChartAfterImport" @change="saveSettings()" />
          <span class="slider round"></span>
        </label>
      </div>

      <div class="setting-row">
        <label>Import forms as single file</label>
        <label class="switch">
          <input type="checkbox" v-model="this.importFormsAsSingleFile" @change="saveSettings()" />
          <span class="slider round"></span>
        </label>
      </div>

      <h2 class="section-header">Account Management</h2>

      <div class="setting-row">
        <label>Secondary Logins (Users)</label>
        <a href="#users" @click.prevent="openModal('user-list')">{{ 1 + store.users.length }} users</a>
      </div>

      <div class="setting-row">
        <label>Practice Names</label>
        <a href="#names" @click.prevent="openModal('practice-name-list')">{{ 1 + (store.account.alternativeNames ?
          store.account.alternativeNames.length : 0)
        }}
          name(s)</a>
      </div>

      <div class="setting-row">
        <label>Public Portal Link</label>
        <a :href="getPublicPortalLink()" target="_blank">{{ getPublicPortalLink() }}</a>
      </div>

      <!-- <div class="setting-row">
        <label><s>Legacy Import</s></label>
        <label class="switch">
          <input type="checkbox" v-model="this.legacyImport" @change="sendNotificationStore()" />
          <span class="slider round"></span>
        </label>
      </div> -->
    </div>
    <transition name="modal" mode="out-in">
      <UserListModal v-if="modal.id == 'user-list'" :account="store.account" :users="store.users"
        @closeModal="closeModal" @openModal="openModal" />
      <PracticeNameListModal v-else-if="modal.id == 'practice-name-list'" :account="store.account"
        @closeModal="closeModal" />
      <CreateUserModal v-else-if="modal.id == 'create-user'" @closeModal="closeModal" />
      <DeleteUserModal v-else-if="modal.id == 'delete-user'" :user="modal.data" @closeModal="closeModal" />
    </transition>
  </div>
</template>

<script>
import UserListModal from "@/modals/account-settings/UserListModal.vue";
import CreateUserModal from "@/modals/account-settings/CreateUserModal.vue"
import DeleteUserModal from "@/modals/account-settings/DeleteUserModal.vue";
import PracticeNameListModal from "@/modals/account-settings/PracticeNameListModal.vue";
import AccountNavbar from "../components/AccountNavbar.vue";
import { store, fetchAccountInfo, setAccountPreferences, fetchUserList } from "@/api";

export default {
  name: "AccountSettingsView",
  data() {
    return {
      newSubmissionEmailNotify: false,
      deleteSubmissionEmailNotify: false,
      openChartAfterImport: false,
      importFormsAsSingleFile: false,
      modal: {
        id: "",
        open: false,
        data: null,
      },
      store
    };
  },
  async created() {
    this.loadAccountInfo();
    fetchUserList(); // Load users to store
  },
  methods: {
    async loadAccountInfo() {
      try {
        await fetchAccountInfo(); // Load account to store
        this.newSubmissionEmailNotify = store.account.newSubmissionEmailNotify;
        this.deleteSubmissionEmailNotify =
          store.account.deleteSubmissionEmailNotify;
        this.openChartAfterImport = store.account.openChartAfterImport;
        this.importFormsAsSingleFile = store.account.importFormsAsSingleFile;
      } catch (err) {
        if (err.message === 'Permission denied') {
          this.$router.replace('/login');
          return;
        }

        alert('Failed to fetch account info: ' + err.message);
      }
    },
    async saveSettings() {
      try {
        await setAccountPreferences({
          newSubmissionEmailNotify: this.newSubmissionEmailNotify,
          deleteSubmissionEmailNotify: this.deleteSubmissionEmailNotify,
          openChartAfterImport: this.openChartAfterImport,
          importFormsAsSingleFile: this.importFormsAsSingleFile
        });
      } catch (err) {
        alert('Changes were not saved: ' + err.message);
      }
    },
    openModal(id, data) {
      this.modal = {
        open: true,
        id: id,
        data: data,
      };
    },
    closeModal() {
      this.modal = {
        open: false,
        id: "",
        data: null,
      };
    },
    getPublicPortalLink() {
      const name = this.store.account.nameUnique;

      const url = new URL(window.location.href);
      return `${url.protocol}//${url.host}/p/${name}`
    }
  },
  components: { AccountNavbar, UserListModal, CreateUserModal, DeleteUserModal, PracticeNameListModal },
};
</script>

<style scoped>
.content {
  width: 100%;
  max-width: 1000px;
  min-height: 700px;
  background: #fff;
  padding: 50px;
  box-shadow: 0px 0px 8px #00000011;
  border-radius: 10px;
  margin: auto;
}

.content-header {
  margin-bottom: 30px;
  display: flex;
  align-items: center;
}

.section-header {
  font-size: 1.2em;
  font-weight: 600;
  color: #333;
  margin: 30px 0 15px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid #f0f0f0;
}

.setting-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 15px;
  min-height: 35px;
  align-items: center;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked+.slider {
  background-color: #2196f3;
}

input:focus+.slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked+.slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>